module.exports = __webpack_public_path__ + "static/media/devincept_logo.97d55f3b.jpg";